module.exports = __webpack_public_path__ + "img/EN_H.03b81ac8.png";